export default function EmptyTag() {
  return <div className="flex w-full h-[100px]">&nbsp;</div>;
}
